export const BALANCE_SLOTS = [
  'company',
  'cost_center',
  'ap',
  'management',
  'operation',
  'area',
  'supplier',
]

export const SUPPLIER_SLOT = 'supplier'

export const BALANCE_SLOT_DIMENSION = {
  company: 'sociedad',
  cost_center: 'ceco',
  ap: 'ap',
  management: 'gerencia',
  operation: 'operacion',
  area: 'area',
}

export const BALANCE_SLOT_LABELS = {
  company: 'Sociedad',
  cost_center: 'CECO',
  ap: 'AP',
  management: 'Gerencia',
  operation: 'Operación',
  area: 'Área',
  supplier: 'Proveedor',
}

export const BALANCE_SLOT_FILTER_FIELD = {
  company: 'company_codes',
  cost_center: 'cost_center_codes',
  ap: 'ap_codes',
  management: 'management_codes',
  operation: 'operation_codes',
  area: 'area_codes',
  supplier: 'supplier_codes',
}

export const findDocumentTypeLabel = (catalog, value) =>
  catalog.find((type) => type.value === value)?.label ?? value

export const buildDocumentTypeCards = (byDocumentType, catalog) => {
  const known = catalog.map(({ value, label }) => ({
    value,
    label,
    amount: byDocumentType[value]?.amount ?? 0,
    count: byDocumentType[value]?.count ?? 0,
  }))
  const unmapped = Object.values(byDocumentType)
    .filter((row) => !catalog.some((type) => type.value === row.document_type))
    .map((row) => ({
      value: row.document_type,
      label: row.label,
      amount: row.amount,
      count: row.count,
    }))
  return [...known, ...unmapped]
}

export const formatSapDate = (value) => value.split('-').reverse().join('/')
export const IDENTITY_CELL = 'committed-identity-cell'

export const COMMITTED_DETAIL_COLUMNS = [
  { key: 'date', title: 'Fecha', width: 110, className: IDENTITY_CELL },
  {
    key: 'document_type',
    title: 'Tipo de documento',
    width: 210,
    ellipsis: true,
    tooltip: true,
    className: IDENTITY_CELL,
  },
  { key: 'document_number', title: 'Nº documento', width: 140, className: IDENTITY_CELL },
  { key: 'company_code', title: 'Sociedad', width: 120, ellipsis: true, tooltip: true },
  { key: 'cost_center_code', title: 'CECO', width: 130, ellipsis: true, tooltip: true },
  { key: 'operation_code', title: 'Operación', width: 110, ellipsis: true, tooltip: true },
  { key: 'management_code', title: 'Gerencia', width: 120, ellipsis: true, tooltip: true },
  { key: 'area_code', title: 'Área', width: 120, ellipsis: true, tooltip: true },
  { key: 'ap_code', title: 'AP', width: 130, ellipsis: true, tooltip: true },
  { key: 'supplier', title: 'Proveedor', width: 180, ellipsis: true, tooltip: true },
  { key: 'comment', title: 'Comentario', width: 200, ellipsis: true, tooltip: true },
  {
    key: 'consumed_amount',
    title: 'Importe',
    width: 120,
    align: 'right',
    amount: true,
    fixed: 'right',
  },
]

export const COMMITTED_DETAIL_WIDTH = COMMITTED_DETAIL_COLUMNS.reduce(
  (total, column) => total + column.width,
  0,
)

const toCriteria = (filters, format) =>
  Object.fromEntries(
    Object.entries(BALANCE_SLOT_FILTER_FIELD).map(([slot, field]) => [
      field,
      format(filters[slot] ?? []),
    ]),
  )

export const toDateRangeParams = (range) => {
  const [from, to] = range ?? []
  return {
    date_from: from ? from.format('YYYY-MM-DD') : '',
    date_to: to ? to.format('YYYY-MM-DD') : '',
  }
}

export const TABLE_FILTER_SLOTS = [
  { column: 'document_type', label: 'Tipo de documento' },
  { column: 'company_code', label: 'Sociedad' },
  { column: 'cost_center_code', label: 'CECO' },
  { column: 'operation_code', label: 'Operación' },
  { column: 'management_code', label: 'Gerencia' },
  { column: 'area_code', label: 'Área' },
  { column: 'ap_code', label: 'AP' },
  { column: 'supplier', label: 'Proveedor' },
]

export const emptyTableFilters = () => ({
  ...Object.fromEntries(TABLE_FILTER_SLOTS.map(({ column }) => [column, []])),
  documentNumber: '',
})

export const toTableFilterParams = (tableFilters) => ({
  ...Object.fromEntries(
    TABLE_FILTER_SLOTS.map(({ column }) => [`table_${column}`, tableFilters[column].join(',')]),
  ),
  document_number: tableFilters.documentNumber,
})

export const toCommittedBody = (filters) => toCriteria(filters, (values) => values)

export const toCommittedCriteria = (filters) => toCriteria(filters, (values) => values.join(','))

export const COMMITTED_COLUMN_SLOT = {
  company_code: 'company',
  cost_center_code: 'cost_center',
  ap_code: 'ap',
  management_code: 'management',
  operation_code: 'operation',
  area_code: 'area',
}

export const findDimensionFor = (slot, dimensions) => {
  const target = BALANCE_SLOT_DIMENSION[slot]
  return dimensions.find((dimension) => (dimension.name || '').trim().toLowerCase() === target)
}

export const extractDimensions = (response) => {
  const payload = response?.payload?.data
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.results)) return payload.results
  if (Array.isArray(payload?.data)) return payload.data
  return []
}

export const toFilterOption = (code, name) => ({
  id: code,
  name,
  description: `${code} ${name}`,
})

export const DEFAULT_DATE_ORDER = 'ascend'
export const toOrderingParam = (dateOrder) => (dateOrder === 'descend' ? '-date' : 'date')

export const toFilterOptions = (dimensionValues) =>
  dimensionValues.map((value) =>
    toFilterOption(
      (value.code_destination || '').trim(),
      (value.name_destination || value.name || '').trim(),
    ),
  )
